'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var prefix = 'fab';
var iconName = 'google';
var width = 488;
var height = 512; // @ts-expect-error TS(7034): Variable 'ligatures' implicitly has type 'any[]' i... Remove this comment to see the full error message

var ligatures = [];
var unicode = 'f1a0';
var svgPathData = 'M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z';
var faGoogle = {
  prefix: prefix,
  iconName: iconName,
  // @ts-expect-error TS(7005): Variable 'ligatures' implicitly has an 'any[]' typ... Remove this comment to see the full error message
  icon: [width, height, ligatures, unicode, svgPathData]
};

exports["default"] = faGoogle;
